import { trapFocus } from '../utilities/accessibility';

const toggleButtons = document.querySelectorAll("#mobile-nav .mobile-nav-dropdown-button");
const showClass = "show";

function handleClick(dropdownMenu) {
	return function (e) {
		e.stopPropagation(); // Prevent the event from bubbling up to the parent toggle button (if any)
		const button = e.currentTarget;
		dropdownMenu.classList.toggle(showClass);
		dropdownMenu.setAttribute('aria-expanded', dropdownMenu.classList.contains(showClass));
		button.setAttribute('aria-pressed', dropdownMenu.classList.contains(showClass));
		button.setAttribute('aria-expanded', dropdownMenu.classList.contains(showClass));
	};
}

function handleKeydown(dropdownMenu, item) {
	return function (event) {
		if (event.key === ' ') {
			event.preventDefault();
			event.stopPropagation(); // Prevent the event from bubbling up to the parent toggle button (if any)
			const button = event.currentTarget;
			dropdownMenu.classList.toggle(showClass);
			dropdownMenu.setAttribute('aria-expanded', dropdownMenu.classList.contains(showClass));
			button.setAttribute('aria-pressed', dropdownMenu.classList.contains(showClass));
			button.setAttribute('aria-expanded', dropdownMenu.classList.contains(showClass));
			trapFocus(item);
		}
	};
}

function initializeMobileNavDropdowns() {
	if(toggleButtons.length <= 0) {
		return;
	}

	toggleButtons.forEach(button => {
		const parentMenuItem = button.closest('.dropdown');
		const dropdownMenu = parentMenuItem.querySelector('.dropdown-menu');
		button.addEventListener('click', handleClick(dropdownMenu));
		button.addEventListener('keydown', handleKeydown(dropdownMenu, parentMenuItem));
	});
}

window.addEventListener('load', initializeMobileNavDropdowns);